import { z } from 'zod';

export enum ValidationItemType {
    PROPERTY = 'PROPERTY',
    COMPOUND = 'COMPOUND',
    CHILD = 'CHILD',
}

export const ValidationItemTypeSchema = z.enum(ValidationItemType);
